export default __webpack_public_path__ + "static/media/Backspace_Ton.98fafdc0.png";